import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export enum UserType {
  Payer = 1,
  Provider = 2,
  Contessa = 3,
  SuperUser = 4,
  System = 5
}

export interface ICompleteUser extends IModelBase {
  FirstName: string
  LastName: string
  Enabled: boolean
  Email: string
  UserName: string
  CanLogin: boolean
  UserTypeId: number
  Phone1: string
  Phone1TypeId: number
  PhoneNumber1Id: number
  Phone2: string
  Phone2TypeId: number
  PhoneNumber2Id: number
  EmailSent: boolean
  CreatedDate: Date
  ModifiedDate: Date
  CreatedBy: string
  ModifiedBy: string
  NurseTypeId: number
  EpisodeTypeId: number
  Npi: string
  RoleId: string
  PlanIds: number[]
  ProviderIds: number[]
  AddedRoleId: string
  AddedPlanIds: number[]
  AddedProviderIds: number[]
  RemovedRoleId: string
  RemovedPlanIds: number[]
  RemovedProviderIds: number[]
  UnitIds: number[]
  ProviderAgencyIds: number[]
  PhysicianTypeIds: number[]
  IsRejected: boolean
  RejectedMessage: string
  NeedsApproval: boolean
}

@Injectable()
export class CompleteUserODataService extends ODataService<ICompleteUser> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'CompleteUsers'
  }
}
